import { post, get, deleteRequest } from './api';

export const authAPI = {
  login(loginData) {
    return post('login', loginData);
  },

  confirmEmail(otp) {
    return post('auth/confirm-email', { otp });
  },

  register(registerData) {
    return post('registration', registerData);
  },

  getUserData() {
    return get('user');
  },

  delete() {
    return deleteRequest('user');
  },

  support(supportData) {
    return post('support', supportData);
  },

  forgot(email) {
    return post('forgot', { email });
  },

  googleLogin(authData) {
    return post('google-login', authData);
  },
};
